import { DomSanitizer } from "@angular/platform-browser";
import { Block } from "./model/block.model";

export function getTamsuiRiver(sanitizer: DomSanitizer): Block[] {
    return [
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/淡水河公約社群版_20240617_v2.png",
            blockImgName: "",
            blockIndex: 0,
            blockName: "block0",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
    ];
}
